define("shared/components/shared/linkinbio/slug-validator/input", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--btnBar u--relative" data-test-id="slug-validator">
    <div class="o--btnGroup cLB--inputGroup {{if @isDisabled 'u--mute'}} {{if @errorMessage 'cLB--inputGroup--error'}}">
      <Shared::Ui::Button
        @class="cLB--inputGroup__label"
        @size="large"
        @text={{t "linkinbio.choose_your_handle.manage_account.url"}}
        @variant="outline"
      />
      <Input
        @type="text"
        @value={{@slug}}
        class="o--form__input--lg cLB--inputGroup__input qa--settingsChangeUserName_input"
        data-test-id="change-handle-input"
        disabled={{@isDisabled}}
        maxlength="30"
        placeholder={{t "linkinbio.view.onboarding.choose_handle.placeholder"}}
        {{autofocus}}
        {{on "input" (perform @validate)}}
        {{on "blur" (if (eq @validate.performCount 0) (perform @validate) (noop))}}
      />
    </div>
    {{#if @validate.isRunning}}
      <Shared::LoadingSpinner @additionalClass="cLB--inputGroup__icon" />
    {{else}}
      {{#if @isValid}}
        {{svg-jar "verified-solid" class="o--icon--md o--icon--success cLB--inputGroup__icon"}}
      {{/if}}
      {{#if @errorMessage}}
        <div class="u--relative u--block u--m__l__xs">
          <p class="u--text--danger u--text--sm u--m__t__xs u--m__b__0" data-test-id="handle-error-message">
            {{@errorMessage}}
          </p>
        </div>
      {{/if}}
    {{/if}}
  
  </div>
  */
  {
    "id": "jX42CcEu",
    "block": "[[[10,0],[14,0,\"o--btnBar u--relative\"],[14,\"data-test-id\",\"slug-validator\"],[12],[1,\"\\n  \"],[10,0],[15,0,[29,[\"o--btnGroup cLB--inputGroup \",[52,[30,1],\"u--mute\"],\" \",[52,[30,2],\"cLB--inputGroup--error\"]]]],[12],[1,\"\\n    \"],[8,[39,1],null,[[\"@class\",\"@size\",\"@text\",\"@variant\"],[\"cLB--inputGroup__label\",\"large\",[28,[37,2],[\"linkinbio.choose_your_handle.manage_account.url\"],null],\"outline\"]],null],[1,\"\\n    \"],[8,[39,3],[[24,0,\"o--form__input--lg cLB--inputGroup__input qa--settingsChangeUserName_input\"],[24,\"data-test-id\",\"change-handle-input\"],[16,\"disabled\",[30,1]],[24,\"maxlength\",\"30\"],[16,\"placeholder\",[28,[37,2],[\"linkinbio.view.onboarding.choose_handle.placeholder\"],null]],[4,[38,4],null,null],[4,[38,5],[\"input\",[28,[37,6],[[30,4]],null]],null],[4,[38,5],[\"blur\",[52,[28,[37,7],[[30,4,[\"performCount\"]],0],null],[28,[37,6],[[30,4]],null],[28,[37,8],null,null]]],null]],[[\"@type\",\"@value\"],[\"text\",[30,3]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[41,[30,4,[\"isRunning\"]],[[[1,\"    \"],[8,[39,9],null,[[\"@additionalClass\"],[\"cLB--inputGroup__icon\"]],null],[1,\"\\n\"]],[]],[[[41,[30,5],[[[1,\"      \"],[1,[28,[35,10],[\"verified-solid\"],[[\"class\"],[\"o--icon--md o--icon--success cLB--inputGroup__icon\"]]]],[1,\"\\n\"]],[]],null],[41,[30,2],[[[1,\"      \"],[10,0],[14,0,\"u--relative u--block u--m__l__xs\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--text--danger u--text--sm u--m__t__xs u--m__b__0\"],[14,\"data-test-id\",\"handle-error-message\"],[12],[1,\"\\n          \"],[1,[30,2]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null]],[]]],[1,\"\\n\"],[13]],[\"@isDisabled\",\"@errorMessage\",\"@slug\",\"@validate\",\"@isValid\"],false,[\"if\",\"shared/ui/button\",\"t\",\"input\",\"autofocus\",\"on\",\"perform\",\"eq\",\"noop\",\"shared/loading-spinner\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/linkinbio/slug-validator/input.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});